import { render, staticRenderFns } from "./League.vue?vue&type=template&id=af7a35bc&"
import script from "./League.vue?vue&type=script&lang=js&"
export * from "./League.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/var/lib/jenkins/workspace/Draft App Client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VProgressLinear } from 'vuetify/lib'
import { VTab } from 'vuetify/lib'
import { VTabs } from 'vuetify/lib'
installComponents(component, {VBreadcrumbs,VContainer,VIcon,VProgressLinear,VTab,VTabs})
